(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description"] && !Shopify.designMode) return;
  try {
    /*
    Tracks clicks on description links tagged with data-ga-event, e.g.
    <a href="/products/new-version" data-ga-event="final_sale_to_new_pdp_click">.
    The attribute value becomes the event name, so new links need no code changes.
    Pushes to dataLayer only: GTM forwards it to GA4 under its own consent settings.
    Delegated from document so it binds once, however many descriptions render.
  */
  (function () {
    function track(event) {
      const link = event.target.closest('.product__description a[data-ga-event]');
      if (!link) return;

      const description = link.closest('.product__description');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: link.dataset.gaEvent,
        source_product_id: description.dataset.productId,
        source_product_handle: description.dataset.productHandle,
        source_url: description.dataset.productUrl,
        destination_url: link.href,
        link_placement: 'product_description',
      });
    }

    document.addEventListener('click', track);
    // Middle-click opens a new tab without firing click.
    document.addEventListener('auxclick', function (event) {
      if (event.button === 1) track(event);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-discount-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    if (e.target.classList.contains('openPopup')) {
      e.preventDefault();
      const overlay = e.target.closest('.storewide-discount-block').nextElementSibling;
      if (overlay && overlay.classList.contains('product-discount-popup-overlay')) {
        overlay.style.display = 'flex';
      }
    }
    if (e.target.classList.contains('product-discount-popup__close') ||
        e.target.closest('.product-discount-popup__close')) {
      const overlay = e.target.closest('.product-discount-popup-overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
    if (e.target.classList.contains('product-discount-popup-overlay')) {
      e.target.style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_size-guide-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-details')) {
    customElements.define(
      'size-guide-details',
      class SizeGuideDetails extends HTMLElement {
        connectedCallback() {
          // CSS hides whichever [data-unit-only] doesn't match data-unit.
          this.querySelectorAll('.size-guide__unit-input').forEach((input) => {
            input.addEventListener('change', () => {
              this.dataset.unit = input.value;
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion-item"] && !Shopify.designMode) return;
  try {
    // Opening an accordion by its heading scrolls its top to 16px below the sticky header (--header-bottom),
  // so the content reads from the start. Accordions open on load don't scroll the page. The scroll is short
  // (250ms on mobile, 400ms from 750px) and stops as soon as the shopper scrolls, taps, clicks or types.
  if (!window.detailsAccordionScroll) {
    window.detailsAccordionScroll = true;
    let opening = null;
    let cancelScroll = null;
    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.details-accordion summary');
      if (summary) opening = summary.parentElement;
    });

    // Eases out to the target over the duration; any shopper input ends it where it is.
    const scrollToTop = (to, duration) => {
      cancelScroll?.();
      const from = window.scrollY;
      const distance = to - from;
      if (Math.abs(distance) < 1) return;
      if (!duration) {
        window.scrollTo({ top: to, behavior: 'instant' });
        return;
      }
      const inputs = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      let frame = 0;
      const stop = () => {
        cancelAnimationFrame(frame);
        inputs.forEach((type) => window.removeEventListener(type, stop));
        cancelScroll = null;
      };
      inputs.forEach((type) => window.addEventListener(type, stop, { passive: true }));
      cancelScroll = stop;
      const start = performance.now();
      const step = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        window.scrollTo({ top: from + distance * (1 - Math.pow(1 - progress, 3)), behavior: 'instant' });
        if (progress < 1) frame = requestAnimationFrame(step);
        else stop();
      };
      frame = requestAnimationFrame(step);
    };

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (details !== opening) return;
        opening = null;
        if (!details.open) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const duration = reduced ? 0 : window.matchMedia('(min-width: 750px)').matches ? 400 : 250;
        const offset = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom')) || 0) + 16;

        // Mobile (no sticky column above the accordion): its top doesn't move as it opens, so scroll right away.
        let sticky = false;
        for (let parent = details.parentElement; parent && !sticky; parent = parent.parentElement) {
          sticky = getComputedStyle(parent).position === 'sticky';
        }
        if (!sticky) {
          requestAnimationFrame(() =>
            scrollToTop(window.scrollY + details.getBoundingClientRect().top - offset, duration)
          );
          return;
        }

        // In the sticky product column (from 750px) the accordion's position depends on its height, so wait
        // for the 0.3s ::details-content transition below (~20 frames, then a steady height, at most ~0.8s).
        const settled = (callback, last = -1, frames = 0) =>
          requestAnimationFrame(() => {
            const height = details.offsetHeight;
            if ((height === last && frames >= 20) || frames > 48) callback();
            else settled(callback, height, frames + 1);
          });
        settled(() => {
          // The column can be taller than the screen: while it's stuck, scrolling doesn't move the accordion, so
          // "scroll by the gap" overshoots. Its top only ever goes up as the page scrolls down, so find the first
          // scroll position that puts it at the offset by bisection (instant jumps, not painted), go back, then
          // scroll there.
          const start = window.scrollY;
          const topAt = (y) => {
            window.scrollTo({ top: y, behavior: 'instant' });
            return details.getBoundingClientRect().top;
          };
          let low = 0;
          let high = document.documentElement.scrollHeight - window.innerHeight;
          if (topAt(high) > offset) {
            low = high;
          } else {
            while (high - low > 1) {
              const mid = Math.floor((low + high) / 2);
              if (topAt(mid) > offset) low = mid;
              else high = mid;
            }
          }
          const end = topAt(low) > offset ? high : low;
          window.scrollTo({ top: start, behavior: 'instant' });
          scrollToTop(end, duration);
        });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
